<template>
  <l-layout :layout="['xs12']" bottom-space>
      <v-card>
        <l-data-table
        title-text="计费规则分类列表"
        :headers="header"
        :get-data-func="getRuleGroupList"
        search-text="请输入类型名称"
        ref="ruleGroupList">
          <template slot="row-action" slot-scope="{item}">
            <td @click.stop class="px-0 mx-0 text-xs-center">
              <v-tooltip left>
                <v-btn @click="deleteRuleGroupConfirm(item)" slot="activator" icon>
                  <v-icon small>$vuetify.icons.delete</v-icon>
                </v-btn>
                <span>删除配置</span>
              </v-tooltip>
            </td>
          </template>
        </l-data-table>
        <l-fixed-btn
          @click="addGroup"
          icon="$vuetify.icons.add"
        ></l-fixed-btn>
      </v-card>
  </l-layout>
</template>
<script>
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../../ladmin/utils/time'
export default {
  name: 'ruleGroupList',
  components: {LDataTable},
  data () {
    return {
      header: [
        {text: '分类名称', value: 'name', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(new Date(v))},
        {text: '创建人', value: 'creator', align: 'left', sortable: false},
        {text: '', value: '', align: 'left', sortable: false}
      ]
    }
  },
  methods: {
    async getRuleGroupList ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('charging/getRuleGroup', {pagination, sortStack, filterItems, search: {key: 'name', value: search}})
      return {items, amount}
    },
    async addGroup () {
      this.$router.push({name: 'ruleGroupForm'})
    },
    async deleteRuleGroupConfirm(item){
      let {res, close} = await this.$L.confirm({
        title: '确认删除该配置？',
        text:'配置名称:'+item.name
      })
      if (res) {
        try {
          await this.deleteRuleGroup(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteRuleGroup(item){
      let res = await this.$store.dispatch('charging/deleteRuleGroup',item.id)
      if(res.data.status+''==='200'){
        this.$L.alert('success',{message:'删除成功'})
        this.$refs.ruleGroupList.refresh()
      }else{
        this.$L.alert('error',{message:'删除失败，原因：'+res.data.msg})
      }
    }
  },
  mounted(){
    this.$refs.ruleGroupList.refresh()
  }
}
</script>
